(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14301],{

/***/ 3190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_Article; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(32924);
// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 4 modules
var MetaTags = __webpack_require__(36003);
// EXTERNAL MODULE: ./components/BlogCommon/Article/index.jsx + 2 modules
var Article = __webpack_require__(12656);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./hocs/withValidateEmail.js
var withValidateEmail = __webpack_require__(54639);
// EXTERNAL MODULE: ./components/Common/SubscribeBlock/styles.module.scss
var styles_module = __webpack_require__(93081);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/SubscribeBlock/index.jsx








var SubscribeBlock = function(param) {
    var isBlog = param.isBlog, email = param.email, handleOnEmailChange = param.handleOnEmailChange, handleOnSubmit = param.handleOnSubmit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), _ = ref[0], ref1 = ref[1], tmp = ref1.data, ref2 = tmp === void 0 ? {} : tmp, isSubscribed = ref2.isSubscribed, message = ref2.message;
    var handleOnClick = function(event) {
        event.preventDefault();
        handleOnSubmit(email.value);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default()).subscribeBlock, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default()).blogPage, isBlog), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).articlePage, !isBlog), _obj)),
        children: [
            !isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).subscribeText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Subscribe to new posts."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Get weekly updates on the newest design stories, case studies and tips right in your mailbox."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (styles_module_default()).subscribeForm,
                        onSubmit: handleOnClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                value: email.value,
                                onChange: handleOnEmailChange,
                                placeholder: "Your email address"
                            }),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).alertMessage,
                                children: message
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).button,
                                onClick: handleOnClick,
                                role: "button",
                                tabIndex: "0",
                                children: "Subscribe"
                            })
                        ]
                    })
                ]
            }),
            isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).subscribeTitle,
                children: "Thank you for being subscribed to the newsletter!"
            })
        ]
    });
};
SubscribeBlock.defaultProps = {
    isBlog: false
};
SubscribeBlock.propTypes = {
    isBlog: (prop_types_default()).bool,
    email: prop_types_default().instanceOf(Object).isRequired,
    handleOnEmailChange: (prop_types_default()).func.isRequired,
    handleOnSubmit: (prop_types_default()).func.isRequired
};
/* harmony default export */ var Common_SubscribeBlock = ((0,withValidateEmail/* withValidateEmail */.l)(SubscribeBlock));

// EXTERNAL MODULE: ./components/Layout/FullLayout/index.jsx
var FullLayout = __webpack_require__(22116);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(53597);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(46616);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ShareThumbnails/styles.module.scss
var ShareThumbnails_styles_module = __webpack_require__(51974);
var ShareThumbnails_styles_module_default = /*#__PURE__*/__webpack_require__.n(ShareThumbnails_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/ShareThumbnails/index.jsx








var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ShareThumbnails = function(param) {
    var url = param.url, title = param.title;
    var asPath = (0,router.useRouter)().asPath;
    var trackSocialShareClick = function(param) {
        var target = param.target;
        ga/* default.trackEvent */.Z.trackEvent("Click social go to share", target.getAttribute("data-socialname"), asPath);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ShareThumbnails_styles_module_default()).socialThumbnails,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                url: url,
                title: title,
                className: (ShareThumbnails_styles_module_default()).svg,
                "data-socialname": "LinkedIn",
                onClick: trackSocialShareClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: constants/* SVG_IMAGES_TYPES.linkedinFilledWhite */.NL.linkedinFilledWhite
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                url: url,
                title: title,
                className: (ShareThumbnails_styles_module_default()).svg,
                "data-socialname": "Twitter",
                onClick: trackSocialShareClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: constants/* SVG_IMAGES_TYPES.twitterFilledWhite */.NL.twitterFilledWhite
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                url: url,
                quote: title,
                className: (ShareThumbnails_styles_module_default()).svg,
                "data-socialname": "Facebook",
                onClick: trackSocialShareClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: "facebookFilledWhite"
                })
            })
        ]
    });
};
ShareThumbnails.defaultProps = {
    title: ""
};
ShareThumbnails.propTypes = {
    url: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/BlogCommon/Article/TagsBlock/index.jsx
var TagsBlock = __webpack_require__(65132);
// EXTERNAL MODULE: ./containers/PageNotFound/index.jsx + 1 modules
var PageNotFound = __webpack_require__(25418);
// EXTERNAL MODULE: ./redux/apis/blog.js + 2 modules
var blog = __webpack_require__(62736);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./hooks/usePageClusters.js
var usePageClusters = __webpack_require__(70080);
// EXTERNAL MODULE: ./containers/Article/utils/propsHelper.js
var propsHelper = __webpack_require__(76259);
;// CONCATENATED MODULE: ./containers/Article/index.jsx





















var FAQ = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5292).then(__webpack_require__.bind(__webpack_require__, 5292));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5292)
            ];
        }
    }
});
var ArticleContainer = function(param) {
    var introSection = param.introSection, query = param.query;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), subscribe = ref[0], ref1 = ref[1], isSubscribeLoading = ref1.isLoading;
    var ref2 = (0,blog/* useGetArticleQuery */.nB)(query), _data = ref2.data, data = _data === void 0 ? {} : _data, isError = ref2.isError, isLoading = ref2.isLoading;
    var article = data.article, olderArticle = data.next, newerArticle = data.prev, related = data.related;
    var pageClusters = (0,usePageClusters/* default */.Z)();
    var ref3 = (0,router.useRouter)(), slug = ref3.query.slug, pathname = ref3.pathname, asPath = ref3.asPath;
    if (isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNotFound/* default */.Z, {});
    }
    if (isLoading) {
        return null;
    }
    // const { slug: prevArticleSlug } = olderArticle;
    // const { slug: nextArticleSlug } = newerArticle;
    var ref4 = (0,propsHelper/* getArticleProps */.R)({
        article: article
    }), articleSlug = ref4.slug, title = ref4.title, oldBody = ref4.oldBody, body = ref4.body, introduction = ref4.introduction, publishedAt = ref4.publishedAt, updatedAt = ref4.updatedAt, tagsList = ref4.tagsList, _categoryTag = ref4.categoryTag, categoryTag = _categoryTag === void 0 ? "" : _categoryTag, metaTitle = ref4.metaTitle, metaDescription = ref4.metaDescription, headImage = ref4.headImage, author = ref4.author, faqList = ref4.faqList;
    var articleMetadata = {
        metaTitle: metaTitle || title && "".concat(title, " | Yellow"),
        metaDescription: metaDescription || title && "Read our new article about ".concat(title, "."),
        publishedAt: publishedAt,
        image: headImage.url,
        keyWords: tagsList.map(function(tag) {
            return tag.title;
        }),
        categoryTag: categoryTag,
        slug: articleSlug,
        url: "".concat(helper/* rootUrl */.Wd).concat(asPath)
    };
    var articleData = {
        metaTitle: metaTitle,
        title: title,
        publishedAt: publishedAt,
        updatedAt: updatedAt,
        headImage: headImage.url,
        articleBody: oldBody || (0,rich_text_plain_text_renderer_es5/* documentToPlainTextString */.a)(body),
        author: author
    };
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.article */.q5.article, {
        title: title,
        slug: articleSlug
    });
    var handleOnFormSubmit = function(email) {
        if (isSubscribeLoading) {
            return;
        }
        subscribe({
            email: email,
            pathname: pathname,
            pageClusters: pageClusters
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.article */.q5.article,
                isArticle: true,
                pageMetadata: articleMetadata,
                breadcrumbs: breadcrumbs,
                microData: articleData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullLayout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        breadcrumbs: breadcrumbs,
                        breadcrumbsTheme: "dark"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Article/* default */.Z, {
                        slug: articleSlug,
                        title: title,
                        oldBody: oldBody,
                        body: body,
                        introduction: introduction,
                        headImage: headImage,
                        introSection: introSection,
                        author: author,
                        publishedAt: publishedAt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareThumbnails, {
                        url: "".concat(helper/* rootUrl */.Wd, "/blog/").concat(slug),
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullLayout/* default */.Z, {
                        disableMaxWidth: true,
                        disableTopPadding: true,
                        disableSidePadding: true,
                        disableBottomPadding: true,
                        children: !!faqList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {
                            isArticalPage: true,
                            faqList: faqList
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsBlock/* TagsBlock */.l, {
                        tags: tagsList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_SubscribeBlock, {
                        handleOnSubmit: handleOnFormSubmit
                    })
                ]
            })
        ]
    });
};
ArticleContainer.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var containers_Article = (ArticleContainer);


/***/ }),

/***/ 70080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePageClusters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62736);
/* harmony import */ var redux_apis_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85144);
/* harmony import */ var utils_appContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16515);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);






function usePageClusters() {
    var pageFetchQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_appContext__WEBPACK_IMPORTED_MODULE_1__/* .PageFetchContext */ .E).pageFetchQuery;
    var ref = (0,redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__/* .useGetArticleQuery */ .nB)(pageFetchQuery), tmp = ref.data, article = (tmp === void 0 ? {} : tmp).article;
    var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getDocumentFields */ .OA)(article, [
        "clusters"
    ]), articleClusters = ref1.clusters;
    var ref2 = (0,redux_apis_page__WEBPACK_IMPORTED_MODULE_4__/* .useFetchPageQuery */ .o)(pageFetchQuery), tmp1 = ref2.data, pageData = tmp1 === void 0 ? {} : tmp1;
    var pageClusters = pageData.clusters;
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(articleClusters || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pageClusters || []));
}


/***/ }),

/***/ 51974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialThumbnails":"styles_socialThumbnails__6PcZO","svg":"styles_svg__D8nvo"};

/***/ }),

/***/ 93081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogPage":"styles_blogPage__xcWS5","articlePage":"styles_articlePage__n0mCc","subscribeTitle":"styles_subscribeTitle___RSFw","subscribeBlock":"styles_subscribeBlock__7aaKr","subscribeText":"styles_subscribeText__WFNbU","subscribeForm":"styles_subscribeForm__239W5","button":"styles_button__a6g7m","alertMessage":"styles_alertMessage__NUCzQ"};

/***/ })

}]);